import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

import { GET_USER_ACCEPTED_CI } from "../../AppConstant";
import UserSeePage from "./See";

function UserAccepted({ setParentLoading, userDetails }) {
    const [accepted, setAccepted] = useState([]);

    const getAccepted = async () => {

        try {
            setParentLoading(true);
            const empid = localStorage.getItem("empid");

            const res = await axios.get(GET_USER_ACCEPTED_CI, {
                params: { empid }
            });
            setAccepted(res.data);
            console.log("API response:", res.data);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        } catch (err) {
            console.error(err);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        }
    };

    useEffect(() => {
        getAccepted();
    }, []);

   
    const [showSeeModal, setShowSeeModal] = useState(false);

    const handleOpenSeeModal = async (item) => {
        localStorage.setItem('swipexid', item.id)
        localStorage.setItem('swipexempid', item.empid)
        setParentLoading(true);
        setShowSeeModal(true);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleCloseSeeModal = () => {
        setParentLoading(true);
        setShowSeeModal(false);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

      const [searchTerm, setSearchTerm] = useState("");
        
            const filteredRecords = accepted.filter((item) => {
            const searchableText = [
                ...Object.values(item),
            ]
                .join(" ")
                .toLowerCase();
        
            return searchableText.includes(searchTerm.toLowerCase());
        });

         const [expandedComment, setExpandedComment] = useState(null);
        
        const handleSeeMore = (index) => {
          setExpandedComment(expandedComment === index ? null : index);
        };

    return (
        <div>

            <div className="input-group mb-3" style={{ width: "500px" }}>
    <span className="input-group-text">
        <i className="bi bi-search"></i>
    </span>

    <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
    />
</div>

            <table className="mt-1 fw-bold" style={{fontSize:"small"}}>
                <thead className="bg-success-subtle" style={{ width:"100%", color:"green" }} >
                    <tr style={{width:"100%"}}>
                        <th style={{width:"5%"}}>S.No</th>
                        <th style={{width:"12%"}}>SWIPEX ID</th>
                        <th style={{width:"25%"}}>TITLE</th>
                        <th style={{width:"22%"}}>REPORTING MANAGER</th>
                        <th style={{width:"10%"}}>ACTION</th>
                        <th style={{width:"13%"}}>CREATED AT</th>
                        <th style={{width:"13%"}}>APPROVED AT</th>
                    </tr>
                </thead>

                <tbody className="text-white" style={{ fontSize: "small" }}>
                    {filteredRecords.length > 0 ? (
                        filteredRecords.map((sub, index) => (
                            <tr key={sub.id}>

                                <td>{index + 1}</td>
                                <td>{sub.id}</td>
                                <td>{sub.title}</td>
                                <td>{sub.validatorname}</td>
                                <td>
                                    <div className="d-flex justify-content-center fw-bold" style={{ fontSize: "18px" }}>
                                        <i class="bi bi-eye-fill" style={{ color: "blue", cursor: "pointer" }} title="See" onClick={() => handleOpenSeeModal(sub)}></i>
                                    </div>
                                </td>

                                 <td>
                                    {new Date(sub.createdat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td> 

                                <td>
                                    {new Date(sub.lastupdatedat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td>      
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="7" style={{ textAlign: "center", color:"white" }}>
                                No records available...!
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>


            <Modal
                show={showSeeModal}
                onHide={handleCloseSeeModal}
                backdrop="static"
                keyboard={false}
                fullscreen
            >
                <UserSeePage handleCloseSeeModal={handleCloseSeeModal} setParentLoading={setParentLoading} userDetails={userDetails} />
            </Modal>

        </div>
    );
}

export default UserAccepted;